import { BlipChat } from 'blip-chat-widget';
import { environment } from '../../utils/environment.utils';

export const startBlipChat = () => {
    if (environment.BLIP_API_KEY && environment.BLIP_CUSTOM_URL) {
        new BlipChat()
            .withAppKey(environment.BLIP_API_KEY)
            .withButton({ color: '#2CC3D5', icon: '' })
            .withCustomCommonUrl(environment.BLIP_CUSTOM_URL)
            .build();
    }
};
